/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable  */
import { React, useState, useEffect, useContext, useRef } from "react"; // , useEffect,useState
// import toast from 'react-hot-toast';
// import { Link } from "react-router-dom"; // , useNavigate
// import { logout, useOutsideClick } from "../Utils"; // , tokenExpire
import "../../Assets/css/header.css";
import images from "../../Resources/Images";
import AppContext from "../../Store/AppContext";
import profileIcon from "../../Assets/images/profileIcon.png";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import NotificationsIcon from "@mui/icons-material/Notifications";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import CloseIcon from "@mui/icons-material/Close";
import RegData_Logo from "../../Assets/Logos/RegData_Logo.png";
import PrivacyPolicyDialog from "../PrivacyPolicyDialog";
import { toast, ToastContainer } from 'react-toastify';
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import PolicyIcon from "@mui/icons-material/Policy";
// import { getUrl } from '../Network/urls';
import { getUrl } from "../../Network/urls";
import { post } from "../../Network/requests";
// import { get } from '../Network/requests';
// import Loader from './UI/Loader';
// import headerProductUrls from '../StaticData/ProductsUrl';
import { setUserProperties } from "../../Analytics/analytics";

function HeaderComponent({ visibility }) {
  // // const history = useNavigate();
  // const refOutside = useRef(null);
  // // const url = getUrl('get-products');
  // const [list, setList] = useState([]);
  // // let optionList = [];
  // // const [clientList, setClientList] = useState([]);
  // const refMobileOutside = useRef(null);
  // const currentPath = window.location.pathname;
  // // const [isLoading, setIsLoading] = useState(false);
  // const [profileClassName, setProfileClassName] = useState("");
  // const [mobileMenuClassName, setMobileMenuClassName] = useState("");
  let [changedClientName, setChangedClientName] = useState("");
  let [showName, setShowName] = useState(false);
  const { clientDetails, handleAPIEncryptValue, setClientDetails } = useContext(AppContext);
  // const clientData = JSON.parse(localStorage.getItem("clientDetails"));
  const profileName = `${clientDetails.firstName} ${clientDetails.lastName}`;
  // const products = JSON.parse(localStorage.getItem('headerProducts'));
  // const clientName = `${clientData.clientName}`;
  // let [clientId, setClientId] = useState(`${clientData.clientId}`);
  console.log(clientDetails);
  // const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  // useOutsideClick(refOutside, () => {
  //   if (profileClassName) {
  //     setProfileClassName("active");
  //   }
  // });

  // useOutsideClick(refMobileOutside, () => {
  //   if (mobileMenuClassName) {
  //     setMobileMenuClassName("active");
  //   }
  // });

  // const handleProfileClassChange = () => {
  //   if (profileClassName) {
  //     setProfileClassName("");
  //   } else {
  //     setProfileClassName("active");
  //   }
  // };

  const fetchClientName = () => {
    setChangedClientName(clientDetails.clientName);
    setShowName(visibility);
    setUserProperties(clientDetails.clientName);
  };

  // const handleMobileMenuClassChange = () => {
  //   if (mobileMenuClassName) {
  //     setMobileMenuClassName("");
  //   } else {
  //     setMobileMenuClassName("active");
  //   }
  // };
  // const initialAccepted = clientDetails.policyAcpt === "True";

  // // initialize badge count and keep it in sync
  // const [notificationsCount, setNotificationsCount] = useState(
  //   initialAccepted ? 0 : 1,
  // );
  // // useEffect(() => {
  // //   setNotificationsCount(initialAccepted ? 0 : 1);
  // // }, [initialAccepted]);
  // // track “just accepted” in local state so we can re-render immediately
  // const [accepted, setAccepted] = useState(initialAccepted);
  // useEffect(() => {
  //   // if clientDetails comes in later from context, pick it up
  //   setAccepted(initialAccepted);
  // }, [initialAccepted]);

  // const refOutside = useRef(null);
  // const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // const toggleDrawer = (open) => () => {
  //   setIsDrawerOpen(open);
  // };
  // useEffect(() => {
  //   // headerProducts();
  //   // handleRegulationName();
  //   fetchClientName();
  // }, []);

  // Menu (notification dropdown) state
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleBellClick = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handlePolicyClick = () => { handleMenuClose(); setPpOpen(true); };
  const handleReleaseClick = () => { handleMenuClose(); setReleaseOpen(true); setReleaseSeen(true); };
  const [accepted, setAccepted] = useState(false);
  const [ppOpen, setPpOpen] = useState(false);

  useEffect(() => {
    const email = clientDetails?.email?.toLowerCase();

    if (!email) return;

    const savedAcceptance =
      localStorage.getItem(`privacyPolicyAccepted:${email}`) === "true";

    const apiAcceptance =
      clientDetails?.policyAcpt === true ||
      String(clientDetails?.policyAcpt).toLowerCase() === "true";

    const isAccepted = savedAcceptance || apiAcceptance;

    setAccepted(isAccepted);
    setPpOpen(!isAccepted);
  }, [clientDetails?.email, clientDetails?.policyAcpt]);

  const handleNotificationAccept = async () => {
    try {
      const url = getUrl("user-signup");

      const plainParams = {
        email: clientDetails.email,
        operation: "policy_update",
      };

      const encryptedParams = handleAPIEncryptValue(
        JSON.stringify(plainParams)
      );

      const response = await post(url, {
        parameters: plainParams,
      });

      console.log("Privacy Policy API Response:", response);

      const result =
        response?.data?.data ??
        response?.data ??
        response;

      // Check the API status code
      const statusCode =
        result?.statusCode ??
        result?.data?.statusCode ??
        response?.status;

      console.log("Detected status code:", statusCode);

      if (Number(statusCode) === 200) {
        const email = clientDetails?.email?.toLowerCase();

        // Update acceptance state
        setAccepted(true);

        if (email) {
          localStorage.setItem(
            `privacyPolicyAccepted:${email}`,
            "true"
          );
        }

        setClientDetails((prev) => ({
          ...prev,
          policyAcpt: "True",
        }));

        // Close the dialog
        setPpOpen(false);

        // Show success notification
        toast.success(
          result?.body?.message ||
          result?.data?.body?.message ||
          "Privacy policy accepted successfully!",
          {
            position: "top-right",
            autoClose: 3000,
            toastId: "privacy-policy-accepted",
          }
        );

      } else {
        toast.error("Could not save privacy policy acceptance.");
        console.error("Unexpected API response:", response);
      }
    } catch (error) {
      console.error("Privacy policy acceptance failed:", error);

      toast.error(
        "Error accepting privacy policy. Please try again."
      );
    }
  };

  return (
    <>
      <header className="rx_header_wrapper">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          newestOnTop
          theme="colored"
        />
        <div className="container" style={{ padding: "0px 22px" }}>
          <div className="rx_header_inner ">
            <div className="">
              <img
                src={images.LogoPng}
                alt="logo"
                style={{ width: "114px", height: "54px", padding: "10px 0px" }}
              />
            </div>
            <h4
              style={{
                color: "#2c7be5",
                fontFamily: "sans-serif",
                fontWeight: 400,
                fontSize: 19,
                marginBottom: 0,
              }}
              className="d-flex align-items-center"
            >
              {/* RegAssure */}
              <div>
                <img
                  src={RegData_Logo}
                  style={{ width: "auto", height: "27px", marginRight: "10px" }}
                  alt="new regassure logo"
                />
              </div>{" "}
              <span style={{ marginBottom: "-9px" }}>UAT</span>
            </h4>
            {/* <h4 className="header_user_name">{productCodeName}</h4> */}
            {/* <h6 className="header_user_name">{regulationName}</h6> */}
            {/* {showName && (
              <div className="rx_header_profle">
                <ul>
                  <li>
                    <h6 className="header_user_name">{changedClientName}</h6>
                  </li>
                </ul>
              </div>
            )} */}
            <ul
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                listStyle: "none",
                margin: 0,
              }}
            >
              {/* Notification Bell with Badge */}
              <li>
                {/* <IconButton onClick={handleBellClick}>
                <Badge badgeContent={notificationsCount} color="error" overlap="circular">
                  <NotificationsIcon style={{ color: '#888' }} />
                </Badge>
              </IconButton> */}
              </li>

              {/* Client Name (if visible) */}
              {showName && (
                <li>
                  <h6
                    className="header_user_name"
                    style={{
                      marginBottom: 0,
                      padding: 0,
                      fontSize: "13px",
                      color: "rgb(44, 123, 229)",
                    }}
                  >
                    {changedClientName}
                  </h6>
                </li>
              )}

              {/* Profile Name + Avatar */}
              <li
                className="header_user_name"
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Avatar
                  alt={clientDetails.firstName}
                  src={profileIcon} // Use actual profile image if available
                  sx={{
                    width: 20,
                    height: 20,
                    bgcolor: "#ffffff",
                    fontSize: "14px",
                  }}
                >
                  {clientDetails.firstName?.[0] || "F"}
                </Avatar>
                <h6
                  style={{
                    margin: 0,
                    padding: 0,
                    color: "rgb(44, 123, 229)",
                    fontSize: "13px",
                  }}
                >
                  {profileName.length > 15
                    ? profileName.slice(0, 15) + "..."
                    : profileName}
                </h6>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {/* Notification dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: { width: 250, padding: "8px 0", borderRadius: 10 },
        }}
        disableScrollLock={true}
      >
        {/* only show this if policy not yet accepted */}
        {/* {!accepted && (
          <MenuItem onClick={handlePolicyClick}>
            <ListItemIcon>
              <PolicyIcon fontSize="small" />
            </ListItemIcon>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2">Accept the Privacy Policy</Typography>
            </div>
          </MenuItem>
        )} */}
      </Menu>
      <PrivacyPolicyDialog
        open={ppOpen}
        onClose={() => setPpOpen(false)}
        onAccept={handleNotificationAccept}
      />
    </>
  );
}

export default HeaderComponent;
